export type BillingSeatInterval = 'month' | 'year'

export interface SeatInfo {
  allowedSeats: number
  additionalSeats: number
  totalSeats: number
  usedSeats: number
  seatPrice: number
  billingInterval: BillingSeatInterval
}

export interface SeatManagerProps {
  seatInfo: SeatInfo
  isLoading?: boolean
  isAddingSeats?: boolean
  isRemovingSeats?: boolean
  onAddSeats: (quantity: number) => void
  onRemoveSeats: (quantity: number) => void
  /** When true, hides the per-seat price row (e.g. for Early Access where seats are free). */
  hideSeatPrice?: boolean
  className?: string
}

export interface RemoveSeatsWarningProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  currentMemberCount: number
  onGoToMembers: () => void
  className?: string
}

export interface AddSeatsConfirmProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  quantity: number
  pricePerSeat: number
  billingInterval: BillingSeatInterval
  isLoading?: boolean
  onConfirm: () => void
  /** When true, hides pricing rows and uses non-purchase language (e.g. for Early Access). */
  isEarlyAccess?: boolean
  className?: string
}

export const ADD_SEATS_OPTIONS = [1, 2, 3, 5, 10] as const
export type AddSeatsOption = (typeof ADD_SEATS_OPTIONS)[number]
